import type { Company } from "@repo/common";
import { resolveOutboundPlaybookCallsEnabled } from "@repo/common";
import { db } from "@repo/ui";
import { doc, onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";

export function useOutboundPlaybookFeatureFlag(company?: Company | null) {
	const [enabled, setEnabled] = useState(false);
	const [globallyDisabled, setGloballyDisabled] = useState(false);

	useEffect(() => {
		return onSnapshot(
			doc(db, "settings", "system"),
			(snapshot) => {
				const settings = snapshot.exists() ? snapshot.data() : null;
				setGloballyDisabled(
					settings?.outboundPlaybookCalls?.disabledForAll === true,
				);
				setEnabled(resolveOutboundPlaybookCallsEnabled(settings, company));
			},
			(error) => {
				console.error("Failed to load outbound Playbook feature flag", error);
				setGloballyDisabled(true);
				setEnabled(false);
			},
		);
	}, [company]);

	return { enabled, globallyDisabled };
}
